import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import Roadmap from "./sections/Roadmap";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Hero />
      <Services />
      <Roadmap />
      <Footer />
    </div>;
}